export default "__VITE_ASSET__OqJAcJnf__"